module.exports = __webpack_public_path__ + "img/a15-hyperlapse.0b0b23b7.png";